export const NIP_REGEX = /\d{10}/i
export const CAR_PLATE_REGEX = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]*$/
export const PROX186_CARD_REGEX = /^\d{3}\.\d{5}$/
export const ACCESS_CARD_NUMBER_REGEX = /^[^A-Za-z\s]*$/i
export const ACCESS_CARD_NUMBER_WITH_COMMA_REGEX = /^\d+[,.]\d+$/i
